import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import userApi from '../../data/api/user/user-api'
import { saveLoggedInUser } from '../../data/auth/auth-storage'


const LoginPage = (): React.JSX.Element => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    setError('')
    setLoading(true)

    try {
      const user = await userApi.login(email, password)

      if (!user || !user.id) {
        setError('Login succeeded, but the user account ID was not returned.')
        return
      }

      saveLoggedInUser(user)

      localStorage.setItem('loggedIn', 'true')
      localStorage.setItem('userId', user.id.toString())

      console.log('Logged-in user:', user)
      console.log('Stored user ID:', localStorage.getItem('userId'))

      navigate('/UserProfile')
    } catch (error) {
      console.error('Login failed:', error)
      setError('Invalid email or password.')
    } finally {
      setLoading(false)
    }
  }

  return (
            <div
          style={{
            minHeight: '100vh',
            width: '100vw',
            marginLeft: 'calc(50% - 50vw)',
            background:
              'linear-gradient(180deg, #0b1220 0%, #0f1724 100%)',
            color: 'white',
            padding: '40px'
          }}
        >
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div
          style={{
            textAlign: 'center',
            marginBottom: '24px'
          }}
        >
          <img
              src="/images/nextquest-logo.png" alt="NextQuest" style={{ height: '200px' }}
            />
        </div>

        <form onSubmit={handleLogin} className="auth-form">
          <div className="auth-field">
            <label htmlFor="email">Email</label>

            <input
              id="email"
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="password">Password</label>

            <input
              id="password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>

          {error && <p>{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default LoginPage